
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.409 5.848l-1.276 14.53H7.785L6.51 5.848l-1.615.142 1.298 14.793c.068.682.66 1.217 1.347 1.217h9.838c.687 0 1.28-.534 1.349-1.226L20.024 5.99l-1.616-.142z","fill":"#000"}}),_c('path',{attrs:{"d":"M15.432 2H9.486c-.745 0-1.35.606-1.35 1.351V5.92h1.62V3.622h5.406v2.297h1.622V3.35c0-.745-.606-1.351-1.352-1.351z","fill":"#000"}}),_c('path',{attrs:{"d":"M21.108 5.108H3.811a.81.81 0 100 1.622h17.297a.81.81 0 100-1.622z","fill":"#000"}})])
          )
        }
      }
    